﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederBsDto from '../Models/VeilederBsDto';

const merEnn40km = 'a1-ja';
const mindreEnn40km = 'a2-nei';

const aValg: RadioButtonValgModel<VeilederBsDto>[] = [
    {
        id: 'a1',
        value: merEnn40km,
        tekst: 'valgMerEnn40Km',
    },
    {
        id: 'a2',
        value: mindreEnn40km,
        tekst: 'valgMindreEnn40Km',
    },
];

export default {
    a1_merEnn40km: merEnn40km,
    a2_mindreEnn40km: mindreEnn40km,
    aValg,
};
